import { HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

type WrapperProps = HTMLAttributes<HTMLDivElement> & {
  isOver?: boolean;
  children?: ReactNode;
  ref?: any;
};

export const Wrapper = styled.div<WrapperProps>`
  height: 100%;
  background-color: ${({ isOver, theme }) =>
    isOver ? theme.palette.backgrounds.dragAndDrop : 'transparent'};
  width: 100%;
`;

type AlignLeftProps = HTMLAttributes<HTMLDivElement> & { children?: ReactNode };

export const AlignLeft = styled.div<AlignLeftProps>`
  display: flex;
  justify-content: flex-end;
`;
